import React, { useState, useEffect } from "react";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import Footer from "../../component/Footer/Footer";
import "./pgmdetails.scss";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import { NotificationManager } from "react-notifications";
import { safeDecode } from "../../common/decoder";
import { pgmdetailAction, approvalAction, userDeactiveAction, fetchGroupAction, updateDiscountGroup } from "../../actions/pgmAction";
import { Modal } from "react-bootstrap";
import Poppup from "../../component/Poppup/index";
import Collapsible from "react-collapsible";
import Loader from "../../component/loaderComponent/Loader";
import { HTTP_STATUS } from "../../constants/httpstatus/HttpsStatus";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import ImagePopup from "../../component/imagepopup/PopupImage";
import { hasPermission } from "../../utils/permissionUtils";
import { PERMISSIONS } from "../../constants/permissions/Permissions";
import GroupPopup from "../../component/GroupPopup/GroupPopup";

function PgmDetails() {
  const [state, setDataState] = useState({
    name: "",
    DOB: "",
    mobile_number: "",
    email: "",
    is_approve: "",
    is_corrected: "",
    is_active: "",
    profile: "",
    is_signup_completed: "",
    privacy_policy_accepted: "",
    type_of_vehicle: "",
    name_of_business: "",
    name_as_per_business_record: "",
    gps_address: "",
    postal_code: "",
    city: "",
    province: "",
    reference_type: "",
    name: "",
    Address: "",
    postal_code: "",
    city_state_name: "",
    phone: "",
    gps_address: null,
    postal_code: null,
    city: null,
    business_data_province: "",
    deatiled_address: null,
    attachment: "",
    distributor: "",
    verification_address_proof: "",
    verification_bank_account_receipt: "",
    verification_rfc: "",
    verfication_constitutive_act: "",
    Verification_id: "",
    // verification_upload_verification_id: "",   // Todo later as per reqirement
    others: "",
    store_photos: "",
    business_data_gps_address: "",
    business_data_postal_code: "",
    detailed_address: "",
    business_ref_Address: "",
    business_ref_city_state_name: "",
    business_ref_id: "",
    business_ref_name: "",
    business_ref_phone: "",
    business_ref_postal_code: "",
    business_ref_reference_type: "",
    personal_ref_Address: "",
    personal_ref_city_state_name: "",
    personal_ref_id: "",
    personal_ref_name: "",
    personal_ref_phone: "",
    personal_ref_postal_code: "",
    personal_ref_reference_type: "",
    business_data_previously_trained_by_tvs: "",
    delivery_address_Address: "",
    delivery_address_postal_code: "",
    delivery_address_city: "",
    delivery_address_province: "",
    delivery_address_detailed_address: "",
  });
  const Country_name = safeDecode(Cookies.get('country_name'));
  const { loading, groupList } = useSelector((state) => state.getGroupReducer)
  const { i18n, t } = useTranslation();
  const language = Cookies.get("language");
  const [pgmDetail, setPgmDetail] = useState([]);
  const [pgmRoles, setPgmRoles] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [selectedDetailGroup, setSelectedDetailGroup]= useState(null);
  const [isDiscountGroup, setIsDiscountGroup] = useState('');
  const formattedData = pgmRoles.map((item) => {
    return `${item.name}`;
  });
  let pgm_role = "";
  if (formattedData.length === 1) {
    pgm_role = formattedData[0];
  } else if (formattedData.length === 2) {
    pgm_role = formattedData.join(" and ");
  } else if (formattedData.length > 2) {
    const lastItem = formattedData.pop();
    pgm_role = `${formattedData.join(", ")} and ${lastItem}`;
  }
  const [isLoading, setIsLoading] = useState(false);
  const [modaldetails, setmodaldetails] = useState({});
  const [modaldetailsbusiness, setmodaldetailsBusiness] = useState({});
  const [collapses, setCollapses] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
  };

  const [checkedItems, setCheckedItems] = useState({});
  const anyCheckboxChecked = Object.values(checkedItems).some((value) => value);

  const handleCheckboxChange = (event) => {
    const newCheckedItems = { ...checkedItems };
    newCheckedItems[event.target.id] = event.target.checked;
    setCheckedItems(newCheckedItems);
    if (event.target.id.startsWith("profile")) {
      const dataLabel = event.target.getAttribute('data-label');
      const checkboxName = event.target.name;
      const updatedModaldetails = { ...modaldetails };
      if (event.target.checked) {
        updatedModaldetails[dataLabel] = {
          name: checkboxName,
          label: dataLabel,
          value: '',
        };
      } else {
        delete updatedModaldetails[event.target.getAttribute('data-label')];
      }
      setmodaldetails(updatedModaldetails);
    } else if (event.target.id.startsWith("businessinput")) {
      const dataLabel = event.target.getAttribute('data-label');
      const checkboxName = event.target.name;
      const updatedModaldetailsbusiness = { ...modaldetailsbusiness };
      if (event.target.checked) {
        updatedModaldetailsbusiness[dataLabel] = {
          name: checkboxName,
          label: dataLabel,
          value: '',
        };
      } else {
        delete updatedModaldetailsbusiness[event.target.getAttribute('data-label')];
      }
      setmodaldetailsBusiness(updatedModaldetailsbusiness);
    } 
  };
  const handleDelete = () => {
    if (checkedItems) {
      const updatedModaldetails = { ...modaldetails };
      const updatedModaldetailsbusiness = { ...modaldetailsbusiness };

      for (const itemId in checkedItems) {
        if (checkedItems[itemId]) {
          // Determine the type based on the item's ID
          if (itemId.startsWith("profile")) {
            const itemName = itemId.replace("profile_", "");
            delete updatedModaldetails[itemName];
          } else if (itemId.startsWith("businessinput")) {
            const itemName = itemId.replace("businessinput_", "");
            delete updatedModaldetailsbusiness[itemName];
          } 
        }
      }

      // Update the states after deleting the selected items
      setmodaldetails(updatedModaldetails);
      setmodaldetailsBusiness(updatedModaldetailsbusiness);
    }
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    PgmDetailData();
    dispatch(fetchGroupAction());
    handleChangeLanguage(language);
  }, []);

  const handleChangeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  const { id } = useParams();
  const decodeid = safeDecode(id);

  async function PgmDetailData() {
    setIsLoading(true);
    let response = await dispatch(pgmdetailAction(decodeid));
    if (response == 200 || response != null) {
      setIsLoading(false);
      setPgmDetail(response.data.data);
      setPgmRoles(response?.data?.data?.user_data?.pgm_role)
      setIsDiscountGroup(response?.data?.meta?.is_discount_group);
      const references = response.data.data?.user_data?.business_references;
      const personalReference = references?.find(
        (reference) => reference?.reference_type === "Personal References"
      );
      const allCommercialReference = (references?.length > 0 && references?.filter(
        (reference) => reference?.reference_type === "Commercial References"
      )) || [];
      const allPersonalReference = (references?.length > 0 && references?.filter(
        (reference) => reference?.reference_type === "Personal References"
      )) || [];
      setDataState({
        ...state,
        name: response.data?.data?.user_data?.name,
        DOB: response.data?.data?.user_data?.DOB,
        mobile_number: response.data.data?.user_data?.mobile_number,
        email: response.data.data?.user_data?.email,
        is_approve: response.data.data?.user_data?.is_approve,
        is_corrected: response.data.data?.user_data?.is_corrected,
        is_active: response.data.data?.user_data?.is_active,
        profile: response.data.data?.user_data?.profile,
        is_signup_completed: response.data.data?.user_data?.is_signup_completed,
        privacy_policy_accepted:
          response.data.data?.user_data?.privacy_policy_accepted,
        type_of_vehicle:
          response.data.data.user_data?.business_data?.type_of_vehicle,
        name_of_business:
          response.data.data?.user_data.business_data?.name_of_business,
        name_as_per_business_record:
          response.data.data?.user_data.business_data
            ?.name_as_per_business_record,
        deatiled_address:
          response.data.data?.user_data.business_data?.detailed_address,
        business_data_postal_code:
          response.data.data?.user_data.business_data?.postal_code,
        gps_address: response.data.data?.user_data.business_data?.gps_address,
        postal_code: response.data.data?.user_data.business_data?.postal_code,
        city: response.data.data?.user_data?.business_data?.city,
        province: response.data.data?.user_data.business_data?.province,
        distributor: response.data.data.user_data?.business_data?.distributor,
        detailed_address:
          response.data.data.user_data?.business_data?.detailed_address,
        business_data_previously_trained_by_tvs:
          response.data.data.user_data.business_data?.previously_trained_by_tvs,
        business_data_province:
          response.data.data.user_data.business_data?.province,
        business_data_gps_address:
          response.data.data.user_data.business_data?.gps_address,
        verification_address_proof:
          response.data.data.user_data.business_data?.address_proof,
        verification_bank_account_receipt:
          response.data.data.user_data.business_data?.bank_account_receipt,
        verification_rfc: response.data.data.user_data.business_data?.rfc,
        verfication_constitutive_act:
          response.data.data.user_data.business_data?.constitutive_act,
        // Todo later as per reqirement
        // verification_upload_verification_id:
        //   response.data.data.user_data?.verification_id,
        Verification_id: response.data.data.user_data?.upload_verification_id,
        business_ref_Address:
          response.data.data.user_data?.business_references[0]?.Address,
        others: response.data.data.user_data.business_data?.others,
        business_ref_city_state_name:
          response.data.data.user_data?.business_references[0]?.city_state_name,
        business_ref_id:
          response.data.data.user_data?.business_references[0]?.id,
        business_ref_name:
          response.data.data.user_data?.business_references[0]?.name,
        business_ref_phone:
          response.data.data.user_data?.business_references[0]?.phone,
        business_ref_postal_code:
          response.data.data.user_data?.business_references[0]?.postal_code,
        business_ref_reference_type:
          response.data.data.user_data?.business_references[0]?.reference_type,
        business_ref_city_state_name_additional: allCommercialReference.length > 1 ? allCommercialReference[1]?.city_state_name : "",
        business_ref_Address_additional: allCommercialReference.length > 1 ? allCommercialReference[1]?.Address : "",
        business_ref_id_additional: allCommercialReference.length > 1 ? allCommercialReference[1]?.id : "",
        business_ref_name_additional: allCommercialReference.length > 1 ? allCommercialReference[1]?.name : "",
        business_ref_phone_additional: allCommercialReference.length > 1 ? allCommercialReference[1]?.phone : "",
        business_ref_postal_code_additional: allCommercialReference.length > 1 ? allCommercialReference[1]?.postal_code : "",
        business_ref_reference_type_additional: allCommercialReference.length > 1 ? allCommercialReference[1]?.reference_type : "",
        store_photos:
          response.data.data?.user_data?.store_photos,
        personal_ref_Address: personalReference?.Address
          ? personalReference?.Address
          : "",
        personal_ref_city_state_name: personalReference?.city_state_name
          ? personalReference?.city_state_name
          : "",
        personal_ref_id: personalReference?.id ? personalReference?.id : "",
        personal_ref_name: personalReference?.name
          ? personalReference?.name
          : "",
        personal_ref_phone: personalReference?.phone
          ? personalReference?.phone
          : "",
        personal_ref_postal_code: personalReference?.postal_code
          ? personalReference?.postal_code
          : "",
        personal_ref_city_state_name_additional: allPersonalReference.length > 1 ? allPersonalReference[1]?.city_state_name : "",
        personal_ref_Address_additional: allPersonalReference.length > 1 ? allPersonalReference[1]?.Address : "",
        personal_ref_id_additional: allPersonalReference.length > 1 ? allPersonalReference[1]?.id : "",
        personal_ref_name_additional: allPersonalReference.length > 1 ? allPersonalReference[1]?.name : "",
        personal_ref_phone_additional: allPersonalReference.length > 1 ? allPersonalReference[1]?.phone : "",
        personal_ref_postal_code_additional: allPersonalReference.length > 1 ? allPersonalReference[1]?.postal_code : "",
        personal_ref_reference_type_additional: allPersonalReference.length > 1 ? allPersonalReference[1]?.reference_type : "",
        delivery_address_Address: response?.data?.data?.user_data?.delivery_address[0]?.gps_address,
        delivery_address_postal_code: response?.data?.data?.user_data?.delivery_address[0]?.postal_code,
        delivery_address_city: response?.data?.data?.user_data?.delivery_address[0]?.city,
        delivery_address_province: response?.data?.data?.user_data?.delivery_address[0]?.province,
        delivery_address_detailed_address: response?.data?.data?.user_data?.delivery_address[0]?.deatiled_address,
      });

      const discountGroupId = response?.data?.data?.user_data?.discount_group?.id;
      if (discountGroupId) {
        setSelectedDetailGroup(discountGroupId.toString());
      }
    } else if (response === undefined) {
      setIsLoading(false);
    }
  }
  const onapproval = async () => {
    setShowModal(false);
    let apiReq = { pgm_status: "Approved" };

    if (isDiscountGroup && selectedGroup !== "") {
      apiReq.discount_group_id = selectedGroup;
    }
    setIsLoading(true);
    let response = await dispatch(approvalAction(apiReq, decodeid));
    if (response == 200 || response != null) {
      setIsLoading(false);
      NotificationManager.success(response.data.message);
      navigate("/pgmlist");
    } else if (response === undefined) {
      setIsLoading(false);
    }
  };
  const handleDeactivateButton = async () => {
    const user_id = decodeid;
    setIsLoading(true);
    let response = await dispatch(userDeactiveAction(user_id));
    if (response.status === HTTP_STATUS.SUCCESS) {
      setIsLoading(false);
      NotificationManager.success(response.data.message);
      navigate("/pgmlist");
    } else if (response === undefined) {
      setIsLoading(false);
    }
  };

  const onNeedCorrection = async () => {
    setShow(true);
  };

  const onclose = () => {
    window.scroll(0, 0);
    navigate("/pgmlist");
  };

  const [activeTab, setActiveTab] = useState("Vehicle Sales Partner");

  const handleTabToggle = (tabName) => {
    setActiveTab(tabName === activeTab ? null : tabName);
  };

  const [isPopupOpens, setIsPopupOpens] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  function openPopups(image) {
    setSelectedImage(image);
    setIsPopupOpens(true)
  }
  function closePopups() {
    setSelectedImage(null);
    setIsPopupOpens(false)
  }

  useEffect(() => {
    if (state?.discount_group?.id) {
      setSelectedGroup(state.discount_group.id);
    }
  }, [state?.discount_group]);

  const handleGroupChange = (e) => {
    setSelectedDetailGroup(e.target.value === "" ? null : e.target.value);
  };
  
  const handleSubmitGroup = async () => {
    let response;
     response =  await dispatch(updateDiscountGroup(decodeid, selectedDetailGroup));
    const { status, message } = response || {};
    if (status === HTTP_STATUS.SUCCESS) {
      NotificationManager.success(message)
    } else {
      return;
    }
  };

  return (
    <div className="details_containers_pgm">
      <div className="pgmcontainers_details">
        <div className="pgmdetails_container">
          <div className="pgmdetails pgm_details_container_s">
            <div className="header_border">
              <p className="pgm-list-header-text">TVS &gt; {t('pgmlist.pgmdetail')}</p>
            </div>
            {isLoading ? (
              <Loader />
            ) : (
              <div>
                {state.is_approve === true ? (
                  <div>
                    <div className="pgmdetails_textbuttons">
                      <span className="details_text">
                        {t('pgmlist.profiledetailsof')} {state?.name?.charAt(0).toUpperCase() + state?.name?.slice(1)}
                        {state.is_active === true ? <button className="pgmactive_button">{t('pgmlist.active')}</button>
                          : <button className="pgmInactive_button">{t('pgmlist.deactivated')}</button>}
                      </span>
                      <div className="pgmdetails_allbutoons">
                        <button
                          className="details_close cursor-pointer"
                          onClick={onclose}
                        >
                          {t('addparts.close')}
                        </button>
                        {hasPermission(PERMISSIONS.CAN_PERFORM_PGM_DEACTIVATE) && (
                          <button
                            className="deactivate_button cursor-pointer"
                            onClick={handleDeactivateButton}
                            disabled={state.is_active === false}
                          >
                            {t('pgmlist.deactivatethisuser')}
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="pgmdetails_role_box">
                      <span className="pgmdetails_firstpara_text">
                        {state.is_approve === true ? "" :
                          <input
                            type="checkbox"
                            className="checkbox"
                            name="Pgm Role"
                            value={pgm_role}
                            id="profile_pgm_role"
                            checked={checkedItems["profile_pgm_role"] || false}
                            onChange={handleCheckboxChange}
                          />
                        }
                        {pgm_role}
                      </span>
                      {/* <button className="change_role_button">
                        Change Role
                      </button>
                      To Do in Next Sprint
                      */}
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="pgmdetails_textbuttons">
                      <span className="details_text">
                        {t('pgmlist.profiledetailsof')} {state?.name?.charAt(0).toUpperCase() + state?.name?.slice(1)}
                      </span>
                      <div className="pgmdetails_allbutoons">
                        <button
                          className="details_close cursor-pointer"
                          onClick={onclose}
                        >
                          {t('addparts.close')}
                        </button>
                        <button
                          className="details_approved cursor-pointer"
                          onClick={() => {
                            if (isDiscountGroup === true) {
                              setShowModal(true);
                            } else {
                              onapproval();
                            }
                          }}
                          disabled={state.is_approve || !state.is_corrected}
                        >
                          {t('pgmlist.approve')}
                        </button>
                        {isDiscountGroup === true && ( 
                          <GroupPopup
                            show={showModal}
                            onClose={() => setShowModal(false)}
                            onSubmit={onapproval}
                            selectedGroup={selectedGroup}
                            setSelectedGroup={setSelectedGroup}
                            groupList={groupList}
                            t={t}
                          />
                        )}
                        {hasPermission(PERMISSIONS.CAN_PERFORM_PGM_CORRECTION) && (
                          <button
                            className="details_need cursor-pointer"
                            disabled={!anyCheckboxChecked || !state.is_corrected}
                            onClick={() => onNeedCorrection()}
                          >
                            {t('pgmlist.needcorrection')}
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="pgmdetails_firstpara_Please">
                      <span className="pgmdetails_firstpara_text_Please">
                        {t('pgmlist.plsselecttext')}
                      </span>
                    </div>
                  </div>
                )}
                <div className="Pgm_Profile_details">
                  <span className="profile_text">{t('pgmlist.profiledetails')}</span>
                  <img src={Image_Url.BORDER} />
                </div>
                <div className="profile_pgm_details">
                  <div className="profilepgm_profileicons">
                    <img
                      className="profile_img"
                      src={
                        state.profile == ""
                          ? Image_Url.PGMDETAILSICONS
                          : state.profile
                      }
                    />
                  </div>
                  <div className="profile_iconstext">
                    <div className="Profile_icon_border">
                      <div className="Profile_icon_text_profiledetails">
                        <div className="checkbox_div">
                          {state.is_approve === true ? "" :
                            <input
                              type="checkbox"
                              className="checkbox"
                              name="name"
                              data-label={t('needCorrectionLabel.nameLabel')}
                              value={state.name}
                              id="profile_name"
                              checked={(checkedItems["profile_name"] && (t('needCorrectionLabel.nameLabel') in modaldetails)) || false}
                              onChange={handleCheckboxChange}
                            />
                          }
                          <div>
                            <span className="Profile_icon_text_span">{t('common.nameLabel')}</span>
                            <p className="Profile_icon_text_para">
                              {state.name}
                            </p>
                          </div>
                        </div>
                        {state.DOB && (
                          <div className="checkbox_div">
                          {state.is_approve === true ? "" :
                            <input
                              type="checkbox"
                              className="checkbox"
                              name="DOB"
                              data-label={t('needCorrectionLabel.dateOfBirthLabel')}
                              value={state.DOB}
                              id="profile_DOB"
                              checked={(checkedItems["profile_DOB"] && (t('needCorrectionLabel.dateOfBirthLabel') in modaldetails)) || false}
                              onChange={handleCheckboxChange}
                            />
                          }
                          <div>
                            <span className="Profile_icon_text_span">
                              {t('addpartner.dateOfBirthLabel')}
                            </span>
                            <p className="Profile_icon_text_para">
                              {state.DOB}
                            </p>
                          </div>
                        </div>
                        )}
                        <div className="checkbox_div">
                          {state.is_approve === true ? "" :
                            <input
                              type="checkbox"
                              className="checkbox"
                              id="profile_mobile_number"
                              name="mobile_number"
                              data-label={t('needCorrectionLabel.mobileNumberLabel')}
                              value={state.mobile_number}
                              checked={
                                (checkedItems["profile_mobile_number"] && (t('needCorrectionLabel.mobileNumberLabel') in modaldetails)) || false
                              }
                              onChange={handleCheckboxChange}
                            />
                          }
                          <div>
                            <span className="Profile_icon_text_span">
                              {t('pgmlist.mobileNumber')}
                            </span>
                            <p className="Profile_icon_text_para">
                              {state.mobile_number}
                              {/* {/* <span className="googlemaptext">Change</span> * To Do In Next Sprint/} */}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="Profilepgmdetails_email">
                      {state.is_approve === true ? "" :
                        <input
                          type="checkbox"
                          className="checkbox"
                          id="profile_email"
                          name="email"
                          data-label={t('needCorrectionLabel.emailIdLabel')}
                          value={state.email}
                          checked={(checkedItems["profile_email"] && (t('needCorrectionLabel.emailIdLabel') in modaldetails)) || false}
                          onChange={handleCheckboxChange}
                        />
                      }
                      <div>
                        <span className="Profile_icon_text_span">{t('addpartner.emailIdLabel')}</span>
                        <p className="Profile_icon_text_para">{state.email}</p>
                      </div>
                    </div>
                  </div>
                </div>
                {state?.is_approve === true && groupList?.length > 0 ? (
                  <div>
                    <div className="Pgm_Profile_questionaire">
                      <span className="profile_text">
                        {t('common.selectGroup')}
                      </span>
                      <img className="group-line-img" src={Image_Url.BORDER} />
                    </div>
                    <div className="select-group-btn">
                      <div className="select-group">
                        <select value={selectedDetailGroup || ""} onChange={handleGroupChange}>
                          <option value="">{t("common.default")}</option>
                        {groupList?.map((group) => (
                          <option key={group?.id} value={group?.id}>{group?.group_name}</option>
                        ))}
                        </select>
                      </div>
                      <div className="save-btn">
                        <button onClick={handleSubmitGroup}>{t('common.submit')}</button>
                      </div>
                    </div>
                  </div>
                ) :
                  ""
                }
                <div className="Pgm_Profile_businees">
                  <span className="profile_text">{t('pgmlist.businesscontact')}</span>
                  <img src={Image_Url.BORDER} />
                </div>
                <div>
                  <div className="Profile_icon_text">
                    <div className="profile_commercials">
                      <div className="checkbox_div">
                        {state.is_approve === true ? "" :
                          <input
                            type="checkbox"
                            className="checkbox"
                            id="businessinput_type_of_vehicle"
                            name="Type of vehicle dealing with"
                            data-label={t('needCorrectionLabel.typeOfVehicleDealingWith')}
                            value={state.type_of_vehicle}
                            checked={
                              checkedItems["businessinput_type_of_vehicle"] && (t('needCorrectionLabel.typeOfVehicleDealingWith') in modaldetailsbusiness) ||
                              false
                            }
                            onChange={handleCheckboxChange}
                          />
                        }
                        <div>
                          <span className="Profile_icon_text_span">
                            {t('pgmlist.typevehicledealingwith')}
                          </span>
                          <p className="Profile_icon_text_para">
                            {state.type_of_vehicle}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="profile_commercials">
                      <div className="checkbox_div">
                        {state.is_approve === true ? "" :
                          <input
                            type="checkbox"
                            className="checkbox"
                            id="businessinput_Distributor"
                            name="Distributor"
                            data-label={t('needCorrectionLabel.distributor')}
                            value={state?.distributor}
                            checked={
                              checkedItems["businessinput_Distributor"] && (t('needCorrectionLabel.distributor') in modaldetailsbusiness) || false
                            }
                            onChange={handleCheckboxChange}
                          />
                        }
                        <div>
                          <span className="Profile_icon_text_span">
                            {t('pgmlist.distributor')}
                          </span>
                          <p className="Profile_icon_text_para">
                            {state?.distributor}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="Profile_icon_text">
                    <div className="profile_commercial">
                      <div className="checkbox_div">
                        {state.is_approve === true ? "" :
                          <input
                            type="checkbox"
                            className="checkbox"
                            id="businessinput_Business/ organization"
                            name="Business/ organization"
                            data-label={t('needCorrectionLabel.businessorg')}
                            value={state.name_of_business}
                            checked={checkedItems["businessinput_Business/ organization"] && (t('needCorrectionLabel.businessorg') in modaldetailsbusiness) || false}
                            onChange={handleCheckboxChange}
                          />
                        }
                        <div>
                          <span className="Profile_icon_text_span">
                            {t('pgmlist.businessorg')}
                          </span>
                          <p className="Profile_icon_text_para">
                            {state.name_of_business}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="profile_commercial">
                      <div className="checkbox_div">
                        {state.is_approve === true ? "" :
                          <input
                            type="checkbox"
                            className="checkbox"
                            id="businessinput_Name as per business record"
                            name="Name as per business record"
                            data-label={t('needCorrectionLabel.namebusinessrecord')}
                            value={state.name_as_per_business_record}
                            checked={checkedItems["businessinput_Name as per business record"] && (t('needCorrectionLabel.namebusinessrecord') in modaldetailsbusiness) || false}
                            onChange={handleCheckboxChange}
                          />
                        }
                        <div>
                          <span className="Profile_icon_text_span">
                            {t('pgmlist.namebusinessrecord')}
                          </span>
                          <p className="Profile_icon_text_para">
                            {state.name_as_per_business_record}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="Profile_icon_text">
                    <div className="profile_commercial">
                      <div className="checkbox_div">
                        {state.is_approve === true ? "" :
                          <input
                            type="checkbox"
                            className="checkbox"
                            id="businessinput_CompleteAddress"
                            name="Complete Address"
                            data-label={t('needCorrectionLabel.completeAddress')}
                            value={state?.detailed_address}
                            checked={
                              checkedItems["businessinput_CompleteAddress"] && (t('needCorrectionLabel.completeAddress') in modaldetailsbusiness) ||
                              false
                            }
                            onChange={handleCheckboxChange}
                          />
                        }
                        <div className="complete-address-pgmdetails">
                          <span className="Profile_icon_text_span">
                            {t('common.completeAddress')}
                          </span>
                          <p className="Profile_icon_text_para">
                            {state.deatiled_address}
                            <span className="googlemaptext">
                              {/* View on google map 
                              To Do in next Sprint  */}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="profile_commercials">
                      <div className="checkbox_div">
                        {state.is_approve === true ? "" :
                          <input
                            type="checkbox"
                            className="checkbox"
                            id="businessinput_City"
                            name="City"
                            data-label={t('needCorrectionLabel.citystate')}
                            value={state.city}
                            checked={checkedItems["businessinput_City"] && (t('needCorrectionLabel.citystate') in modaldetailsbusiness) || false}
                            onChange={handleCheckboxChange}
                          />
                        }
                        <div>
                          <span className="Profile_icon_text_span">{t('common.city')}</span>
                          <p className="Profile_icon_text_para">{state.city}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="Profile_icon_text">
                    <div className="profile_commercial">
                      <div className="checkbox_div">
                        {state.is_approve === true ? "" :
                          <input
                            type="checkbox"
                            className="checkbox"
                            id="businessinput_PostalCode"
                            name="Postal Code"
                            data-label={t('needCorrectionLabel.postalcode')}
                            value={state.business_data_postal_code}
                            checked={
                              checkedItems["businessinput_PostalCode"] && (t('needCorrectionLabel.postalcode') in modaldetailsbusiness) || false
                            }
                            onChange={handleCheckboxChange}
                          />
                        }
                        <div>
                          <span className="Profile_icon_text_span">
                            {t('common.postalcode')}
                          </span>
                          <p className="Profile_icon_text_para">
                            {state.business_data_postal_code}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="profile_commercials">
                      <div className="checkbox_div">
                        <div>
                          <span className="Profile_icon_text_span">
                            {t('pgmlist.receivetraining')}
                          </span>
                          <p className="Profile_icon_text_para">
                            {state.business_data_previously_trained_by_tvs === true ? "Yes" : "No"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="Profile_icon_text">
                    <div className="profile_commercial">
                      <div className="checkbox_div">
                        {state.is_approve === true ? "" :
                          <input
                            type="checkbox"
                            className="checkbox"
                            id="businessinput_business_data_province"
                            name="Province/State"
                            data-label={t('needCorrectionLabel.provinceState')}
                            value={state.business_data_province}
                            checked={checkedItems["businessinput_business_data_province"] && (t('needCorrectionLabel.provinceState') in modaldetailsbusiness) || false}
                            onChange={handleCheckboxChange}
                          />
                        }
                        <div>
                          <span className="Profile_icon_text_span">
                            {t('common.provinceState')}
                          </span>
                          <p className="Profile_icon_text_para">
                            {state.business_data_province}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="profile_commercial">
                      <div className="checkbox_div">
                        {state.is_approve === true ? "" :
                          <input
                            type="checkbox"
                            className="checkbox"
                            id="businessinput_business_location_pincode"
                            name="Province/State"
                            data-label={t('needCorrectionLabel.locationpincode')}
                            value={state.gps_address}
                            checked={checkedItems["businessinput_business_location_pincode"] && (t('needCorrectionLabel.locationpincode') in modaldetailsbusiness) || false}
                            onChange={handleCheckboxChange}
                          />
                        }
                        <div>
                          <span className="Profile_icon_text_span">
                            {t('needCorrectionLabel.locationpincode')}
                          </span>
                          <p className="Profile_icon_text_para">
                            {state.gps_address}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  {state.delivery_address_Address && (
                    <>
                      {state.delivery_address_detailed_address + ", " + state.delivery_address_Address === state.deatiled_address + ", " + state.gps_address &&
                        <p className="same_address_para">{t('pgmlist.usingsameaddress')}</p>
                      }
                      {state.delivery_address_detailed_address + ", " + state.delivery_address_Address !== state.deatiled_address + ", " + state.gps_address && (
                        <div>
                          <div className="Pgm_Profile_verification">
                            <span className="profile_text">{t('common.deliveryaddress')}</span>
                            <img src={Image_Url.BORDER} />
                          </div>
                          <div className="Profile_icon_text">
                            <div className="profile_commercials">
                              <div className="checkbox_div">
                                {state.is_approve === true ? "" :
                                  <input
                                    type="checkbox"
                                    className="checkbox"
                                    id="delivery_complete_address"
                                    name="Complete Address"
                                    value={state.delivery_address_detailed_address}
                                    checked={
                                      checkedItems["delivery_complete_address"] && ("Complete Address" in modaldetailsbusiness) ||
                                      false
                                    }
                                    onChange={handleCheckboxChange}
                                  />
                                }
                                <div>
                                  <span className="Profile_icon_text_span">
                                    {t('common.completeAddress')}
                                  </span>
                                  <p className="Profile_icon_text_para">
                                    {state.delivery_address_detailed_address}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="profile_commercials">
                              <div className="checkbox_div">
                                {state.is_approve === true ? "" :
                                  <input
                                    type="checkbox"
                                    className="checkbox"
                                    id="delivery_city"
                                    name="City"
                                    value={state.delivery_address_city}
                                    checked={
                                      checkedItems["delivery_city"] && ("City" in modaldetailsbusiness) || false
                                    }
                                    onChange={handleCheckboxChange}
                                  />
                                }
                                <div>
                                  <span className="Profile_icon_text_span">
                                    {t('common.city')}
                                  </span>
                                  <p className="Profile_icon_text_para">
                                    {state.delivery_address_city}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="Profile_icon_text">
                            <div className="profile_commercial">
                              <div className="checkbox_div">
                                {state.is_approve === true ? "" :
                                  <input
                                    type="checkbox"
                                    className="checkbox"
                                    id="delivery_address_postal_code"
                                    name="Postal Code"
                                    value={state.delivery_address_postal_code}
                                    checked={checkedItems["delivery_address_postal_code"] && ("Postal Code" in modaldetailsbusiness) || false}
                                    onChange={handleCheckboxChange}
                                  />
                                }
                                <div>
                                  <span className="Profile_icon_text_span">
                                    {t('common.postalcode')}
                                  </span>
                                  <p className="Profile_icon_text_para">
                                    {state.delivery_address_postal_code}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="profile_commercial">
                              <div className="checkbox_div">
                                {state.is_approve === true ? "" :
                                  <input
                                    type="checkbox"
                                    className="checkbox"
                                    id="delivery_address_province_state"
                                    name="Province/State"
                                    value={state.delivery_address_province}
                                    checked={checkedItems["delivery_address_province_state"] && ("Province/State" in modaldetailsbusiness) || false}
                                    onChange={handleCheckboxChange}
                                  />
                                }
                                <div>
                                  <span className="Profile_icon_text_span">
                                    {t('common.provinceState')}
                                  </span>
                                  <p className="Profile_icon_text_para">
                                    {state.delivery_address_province}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="Profile_icon_text">
                            <div className="profile_commercials">
                              <div className="checkbox_div">
                                {state.is_approve === true ? "" :
                                  <input
                                    type="checkbox"
                                    className="checkbox"
                                    id="delivery_complete_location_pincode"
                                    name="location pincode"
                                    value={state.delivery_address_Address}
                                    checked={
                                      checkedItems["delivery_complete_location_pincode"] && ("location pincode" in modaldetailsbusiness) ||
                                      false
                                    }
                                    onChange={handleCheckboxChange}
                                  />
                                }
                                <div>
                                  <span className="Profile_icon_text_span">
                                    {t('common.location/pincode')}
                                  </span>
                                  <p className="Profile_icon_text_para">
                                    {state.delivery_address_Address}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      )}
                    </>
                  )}
                </div>

                <div className="pgm_details_eight_paras">
                  <div className="veryfication_img">
                    <div className="checkbox_divs">
                      {state.is_approve === true ? "" :
                        <input
                          type="checkbox"
                          className="checkbox"
                          id="businessinput_Photos_of_your_store"
                          name="Photos_of_your_store"
                          data-label={t('needCorrectionLabel.photostore')}
                          value={state.store_photos}
                          checked={
                            checkedItems["businessinput_Photos_of_your_store"] && (t('needCorrectionLabel.photostore') in modaldetailsbusiness) ||
                            false
                          }
                          onChange={handleCheckboxChange}
                        />
                      }
                      <span>{t('businessdetail.photostrore')}</span>
                    </div>
                    <div className="flex-img-pgm">
                      {
                        state?.store_photos?.length > 0 ?
                          state?.store_photos?.map((val) => {
                            return <img
                              className="store-img"
                              src={
                                val.attachment
                                  ? val.attachment
                                  : Image_Url.DEFAULT_STORE_IMAGE
                              }
                            />
                          })
                          :
                          <img
                            className="store-img"
                            src={Image_Url.DEFAULT_STORE_IMAGE}
                          />
                      }
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="details_pgm"></div>
          <Modal
            className="expertise-modal montserrat-font"
            show={show}
            onHide={handleClose}
          >
            <Modal.Body className="p-0">
              {checkedItems && (
                <Poppup
                  handleClose={handleClose}
                  modaldetail={modaldetails}
                  setmodaldetails={setmodaldetails}
                  setmodaldetailsBusiness={setmodaldetailsBusiness}
                  modaldetailsbusiness={modaldetailsbusiness}
                  userid={decodeid}
                  handleDelete={handleDelete}
                />
              )}
            </Modal.Body>
          </Modal>
        </div>
      </div>
      <div className="footer-div">
        <Footer />
      </div>
    </div>
  );
}

export default PgmDetails;
